import { TAX_DEDUCTIBLE } from '../types';

export const taxDeductibles = [
  TAX_DEDUCTIBLE.PARTIAL,
  TAX_DEDUCTIBLE.YES,
  TAX_DEDUCTIBLE.SPLIT,
];
